<template>
  <selector
    draggable-group="choices"
    item-name-plural="choice templates"
    item-name="choice template"
    v-model="choiceTemplates"
    :category-list="choiceCategoryList"
    :disabled-ids="selectorDisabledTemplateIds"
    :is-fixed="isFixed"
    :is-editable="isEditable"
    :search-text="selectorTemplateSearchText"
    :selected-category-id="selectorSelectedTemplateCategory"
    :selected-id="selectorSelectedTemplateId"
    @onItemAdd="handleAddTemplate"
    @onItemEdit="handleEditTemplate"
    @onChangeCategory="handleSelectCategory"
    @onLoadMore="handleLoadMore"
    @onSelect="handleSelectTemplate"
    @onResetFilters="handleResetFilters"
    @onChangeSearchText="handleSearchText"
  ></selector>
</template>

<script>
import { debounce } from 'lodash';
import { mapGetters, mapState } from 'vuex';

import { expandChoiceTemplate } from '../utils';
import Selector from './Selector';

const DEBOUNCE_DELAY = 600;

export default {
  name: 'ChoiceTemplateSelector',
  components: {
    Selector,
  },
  props: {
    isFixed: {
      type: Boolean,
      default: false,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    selectedId: null,
  }),
  computed: {
    ...mapState('surveybuilder', [
      'choiceTemplateList',
      'choiceTemplatesLoading',
      'choiceTemplatesPage',
      'choiceCategoryList',
      'selectorSelectedTemplateId',
      'selectorSelectedTemplateCategory',
      'selectorTemplateSearchText',
    ]),
    ...mapState('user', ['me']),
    ...mapGetters('surveybuilder', ['canvasSelectedQuestion', 'selectorDisabledTemplateIds']),

    choiceTemplates() {
      return this.choiceTemplateList.map(template => {
        if (template.isGlobal) {
          return {
            ...template,
            isEditable: this.me.is_staff,
          };
        }
        return { ...template, isEditable: true };
      });
    },
  },
  methods: {
    handleAddTemplate(template) {
      const choices = expandChoiceTemplate(template);
      this.$store.dispatch('surveybuilder/canvasAddChoices', choices);
    },

    handleEditTemplate(template) {
      this.$store.dispatch('surveybuilder/choiceTemplateShowEditDialog', {
        template,
        choices: template.choices,
      });
    },

    handleSelectTemplate(template) {
      this.$store.dispatch('surveybuilder/selectorSelectTemplateId', template.id);
    },

    handleSelectCategory(categoryId) {
      this.$store.dispatch('surveybuilder/selectorSelectTemplateCategory', categoryId).then(() => {
        this.$store.dispatch('surveybuilder/getChoiceTemplates');
      });
    },

    handleSearchText(text) {
      this.$store.dispatch('surveybuilder/selectorSetTemplateSearchText', text);
      this.handleDebounceGetTemplates();
    },

    handleResetFilters() {
      this.$store.dispatch('surveybuilder/selectorResetTemplateFilters');
      this.$store.dispatch('surveybuilder/getChoiceTemplates');
    },

    // eslint-disable-next-line
    handleDebounceGetTemplates: debounce(function() {
      this.$store.dispatch('surveybuilder/getChoiceTemplates');
    }, DEBOUNCE_DELAY),

    handleLoadMore() {
      if (this.choiceTemplateList.length && !this.choiceTemplatesLoading) {
        this.$store.dispatch('surveybuilder/getMoreChoiceTemplates');
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// ChoiceTemplateSelector.vue?efe524a4